import React from "react";
import { Component } from "react";
import LoadPointCloudModal from "../LoadPointCloudModal";
import PointCloudWindow from "../PCViewer/PointCloudWindow";
import { LoadablePointCloud } from "../types/LoadablePointCloud";
import LogoutButton from "../Logout";

interface State {}

interface Props {
	LIDAR_VIEW: React.RefObject<PointCloudWindow>;
	loadPointCloud: (pc: LoadablePointCloud) => void;
  getAccessTokenSilently: () => Promise<string>
}

export default class Header extends Component<Props, State> {
    CHOOSE_POINT_CLOUD_MODAL: React.RefObject<LoadPointCloudModal>;

    constructor(props: Props) {
        super(props);
        this.CHOOSE_POINT_CLOUD_MODAL = React.createRef();
    }

    componentDidMount() {}


    // Loads a point cloud by calling our load point cloud props function
    loadPointCloud = (pc: LoadablePointCloud) => {
        this.props.loadPointCloud(pc);
    };

    render() {
        return (
            <>
                <div className="header-container">
                    <div className="doppel-logo" />
                    <LogoutButton />
                </div>
                <LoadPointCloudModal
                    getAccessTokenSilently={this.props.getAccessTokenSilently} 
                    ref={this.CHOOSE_POINT_CLOUD_MODAL}
                    onLoad={this.loadPointCloud}
                />
            </>
        );
    }
}
